import { colors } from 'shared/styles/colors'
import styled from 'styled-components'

export const StyledButtonFile = styled.input`
  display: none;
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  z-index: -1;

  text-align: center;
`
export const Button = styled.label`
  display: flex;

  align-items: center;
  justify-content: center;

  width: 159px;
  height: 44px;

  align-self: center;

  background: transparent;
  color: ${colors.green};

  border-radius: 4px;
  cursor: pointer;

  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 14px;

  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.8);
  }

  img {
    width: 12px;
    height: 12px;
    margin-right: 10px;
  }
`

export const SubTitle = styled.span`
  font-size: 16px;
  color: ${colors.white};

  align-self: center;

  margin-top: 10px;
`

export const FileText = styled.span`
  font-size: 16px;
  font-style: italic;

  color: ${colors.greenLight};

  align-self: center;

  margin-top: 10px;
`
